import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import { paths } from './loginGeneratedTypes'

interface Params {
  authorization?: string
}
export class LoginApiClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.LOGIN,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}
